import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonElafronApostrofos';
const args = {};

export class OligonElafronApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
